import { IError } from '@checkout/errors';
import { IMarketChangeSuccessPayload } from '@checkout/payloadTypes';
import { RootState } from '@checkout/state';
import { AxiosResponse } from 'axios';
import { Epic } from 'redux-observable';
import 'rxjs'; // tslint:disable-line no-import-side-effect import-blacklist
import { fromPromise as fromPromise$ } from 'rxjs/observable/fromPromise';
import { of as of$ } from 'rxjs/observable/of';
import { RootAction } from '../actions/actionTypes.d';
import ActionTypes from './../actions/actionTypes';
import { MarketChangeRequestAction } from './../actions/actionTypes.d';
import { marketChangeSuccess, setErrors } from './../reducers/checkout';
import { rest } from './../utils/apiUtils';
import { logger } from './../utils/logger';

export const changeMarketEpic: Epic<RootAction, RootAction, RootState> =
  (action$, state$) => action$
    .ofType(ActionTypes.CHANGE_MARKET_CONTEXT_REQUEST)
    .mergeMap((action: MarketChangeRequestAction) => {
      const { country, language } = action.payload;

      return fromPromise$(rest.httpPut(`/countries/${country}`, { language }))
        .flatMap((response: AxiosResponse<IMarketChangeSuccessPayload>) => {
          return of$(marketChangeSuccess(response.data));
        });
    })
    .catch((error: IError) => {
      logger(error);
      return of$(setErrors(error));
    });



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/market.ts